import { DynamicFormV2Palette } from "@mui/material";

export type FormGlobalTokenType = {
  focusOutlineColor: string;
  scrollbarThumbColor: string;
};

export const assignGlobalTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    focusOutlineColor: formsPalette.border.quiet,
    scrollbarThumbColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.quiet,
  } as FormGlobalTokenType;
};
